import { NavLink, Outlet } from 'react-router-dom';
import { useI18n } from '../app/context';
import { Icon, type IconName } from './Icon';
import styles from './shell.module.css';

interface NavItem {
  to: string;
  icon: IconName;
  labelKey: 'nav.collection' | 'nav.insights' | 'nav.add' | 'nav.wishlist' | 'nav.settings';
  add?: boolean;
}

const ITEMS: NavItem[] = [
  { to: '/', icon: 'grid', labelKey: 'nav.collection' },
  { to: '/insights', icon: 'chart', labelKey: 'nav.insights' },
  { to: '/add', icon: 'plus', labelKey: 'nav.add', add: true },
  { to: '/wishlist', icon: 'bookmark', labelKey: 'nav.wishlist' },
  { to: '/settings', icon: 'sliders', labelKey: 'nav.settings' },
];

function Items() {
  const { t } = useI18n();

  return ITEMS.map((item) => (
    <NavLink
      key={item.to}
      to={item.to}
      end={item.to === '/'}
      className={({ isActive }) =>
        [styles.item, item.add && styles.itemAdd, isActive && styles.itemActive]
          .filter(Boolean)
          .join(' ')
      }
    >
      <span className={styles.itemIcon}>
        <Icon name={item.icon} size={22} />
      </span>
      <span className={styles.itemLabel}>{t(item.labelKey)}</span>
    </NavLink>
  ));
}

export function AppShell() {
  const { t } = useI18n();

  return (
    <div className={styles.shell}>
      <a className="skip-link" href="#main">
        {t('nav.skipToContent')}
      </a>

      <nav className={styles.rail} aria-label={t('nav.collection')}>
        <NavLink to="/" className={styles.wordmark}>
          <span className={styles.spines} aria-hidden="true">
            <span />
            <span />
            <span />
          </span>
          Physical Movies
        </NavLink>
        <Items />
      </nav>

      <main id="main" className={styles.main}>
        <div className={styles.mainInner}>
          <Outlet />
        </div>
      </main>

      <nav className={styles.bar} aria-label={t('nav.collection')}>
        <Items />
      </nav>
    </div>
  );
}
